/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upgrade_Modal_SpecsInputs */

const en_upgrade_modal_specs = /** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tier} Plan Specifications`)
};

const es_upgrade_modal_specs = /** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Especificaciones del Plan ${i?.tier}`)
};

const fr_upgrade_modal_specs = /** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spécifications du forfait ${i?.tier}`)
};

const de_upgrade_modal_specs = /** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tier} Plan-Spezifikationen`)
};

const id_upgrade_modal_specs = /** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spesifikasi Paket ${i?.tier}`)
};

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const ja_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const zh_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const ar_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const it_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const ru_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const pt_upgrade_modal_specs = en_upgrade_modal_specs;

/** @type {(inputs: Upgrade_Modal_SpecsInputs) => LocalizedString} */
const ko_upgrade_modal_specs = en_upgrade_modal_specs;

/**
* | output |
* | --- |
* | "{tier} Plan Specifications" |
*
* @param {Upgrade_Modal_SpecsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_specs = /** @type {((inputs: Upgrade_Modal_SpecsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_SpecsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_specs(inputs)
	if (locale === "es") return es_upgrade_modal_specs(inputs)
	if (locale === "fr") return fr_upgrade_modal_specs(inputs)
	if (locale === "de") return de_upgrade_modal_specs(inputs)
	if (locale === "ja") return ja_upgrade_modal_specs(inputs)
	if (locale === "zh") return zh_upgrade_modal_specs(inputs)
	if (locale === "ar") return ar_upgrade_modal_specs(inputs)
	if (locale === "id") return id_upgrade_modal_specs(inputs)
	if (locale === "it") return it_upgrade_modal_specs(inputs)
	if (locale === "ru") return ru_upgrade_modal_specs(inputs)
	if (locale === "pt") return pt_upgrade_modal_specs(inputs)
	return ko_upgrade_modal_specs(inputs)
});